import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-gray-400 py-8 sm:py-10 md:py-12 text-center" data-id="element-94">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <h4 className="text-white font-heading font-bold text-lg sm:text-xl mb-3 sm:mb-4" data-id="element-96">
          🫁 KIT BRONQUIOS LIBRES™ 2026 — SISTEMA DE CONTROL ASMÁTICO INFANTIL
        </h4>
        <p className="mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed text-sm sm:text-base" data-id="element-97">
          El sistema de control del asma infantil N°1 para madres argentinas.
          Porque tu hijo merece respirar libre y vos merecés dormir tranquila.
        </p>
        <div className="text-xs sm:text-sm mb-6 sm:mb-8 space-x-2 md:space-x-4" data-id="element-98">
          <span data-id="element-99">soportenexorecursos@gmail.com</span>
          <span className="text-gray-600" data-id="element-100">•</span>
          <span data-id="element-101">@nexorecursoss</span>
        </div>
        <div className="text-xs text-gray-600 border-t border-gray-800 pt-6 sm:pt-8" data-id="element-102">
          © Kit Bronquios Libres™ 2026 — Sistema de Control Asmático Infantil
          — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
};